import React from 'react'
import Mapa from '../../assets/images/mapa-cobertura/mapa-cobertura@3x.png'
import './style.scss'

export default function SectionRoof() {
	return (
		<section className="section-roof-container">
			<section className="container-text">
				Estamos em todas as rodovias pedagiadas do país, além de estacionamentos de shoppings e aeroportos.
			</section>
			<section className="img-container">
				<img width="100%" alt="Mapa" src={Mapa} />
			</section>
		</section>
	)
}